import { Question, Segment } from "hp-types";

const checkDTKFilter = (DTKFilter: boolean, question: Question) => {
  return DTKFilter ? true : question.segment !== Segment.DTK;
};

export default checkDTKFilter;
